import React from "react";
import "./ProjectControlDrawer.css";
import { hasRoles } from "../../utils/roles";

export default function ProjectControlDrawer(props) {
  const { Component } = props;
  const { user } = props;
  const { label } = props;
  const { show1, setShow1 } = props;
  const { setShow2, setShow3, setShow4 } = props;
  const { dashboardSelect, dashboardType } = props;

  if (dashboardSelect !== "DASHBOARD") {
    if (dashboardSelect !== dashboardType) {
      return null;
    }
  }

  let button = "drawer-button";
  if (show1) {
    button = "drawer-button-clicked";
  }

  if (!hasRoles(user.roles, ["CostManager"])) {
    return null;
  }

  return (
    <div className="project-control-drawer">
      <button
        className={button}
        onClick={() => {
          setShow1(!show1);
          setShow2(false);
          setShow3(false);
          setShow4(false);
        }}
      >
        {label}
      </button>

      {show1 && (
        <div className="project-control-drawer-content">
          <Component {...props} />
        </div>
      )}
    </div>
  );
}
